<script setup lang="ts">

import {Dialog, DialogHeader, DialogScrollContent, DialogTitle} from "@/core/components/ui/dialog";
import {HistogramInterval, HistogramIntervalOption, SupportProgramMarketStatistic} from "@/program/interfaces/Program";
import ProgramKeyIndicator from "@/program/components/program-statistics/ProgramKeyIndicator.vue";
import IntervalOption from "@/program/components/program-statistics/dialog/IntervalOption.vue";
import {ref, watch} from "vue";
import {programApi} from "@/container";

const props = defineProps<{
    item: SupportProgramMarketStatistic | null;
    supportProgramId: number;
    index: number;
}>();

const emits = defineEmits<{
    (e: 'update:open', value: boolean): void;
}>();

const copy = ref<null | SupportProgramMarketStatistic>(null);
const loading = ref(false);

watch(() => props.item, (newValue) => {
    copy.value = newValue ? {...newValue} : null;
}, {immediate: true});


const intervalUpdated = (value: string) => {
    loading.value = true;
    programApi().statistic(props.supportProgramId, props.index, {interval: value})
        .then(updatedStatistic => {
            copy.value = updatedStatistic;
        })
        .finally(() => {
            loading.value = false;
        });
};
</script>

<template>
  <Dialog :open="!!copy" @update:open="emits('update:open', $event)">
    <DialogScrollContent v-if="copy" class="h-[60vh] min-w-[80%] overflow-y-auto flex flex-col">
      <DialogHeader>
        <DialogTitle>
          {{ copy.label }}
        </DialogTitle>
      </DialogHeader>
      <div class="flex justify-end">
        <IntervalOption
          v-if="copy.available_options?.interval
            && Object.keys(copy.available_options.interval).length > 0
            && !!copy.options?.interval"
          :available-options="copy.available_options?.interval as HistogramIntervalOption"
          :default="copy.options.interval as HistogramInterval"
          :disabled="loading"
          @update:interval="intervalUpdated"
        />
      </div>
      <ProgramKeyIndicator
        :item="copy"
        :index="index"
        :support-program-id="supportProgramId"
        :full-screen="true"
        class="flex-1 min-h-0 shrink-1"
      />
    </DialogScrollContent>
  </Dialog>
</template>
